import { Injectable } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { RejectSummariesModalComponent } from './reject-summaries-modal.component';
import { FormInstancesService } from '@app/api/api-services/form-instances.service';
import { TokenStorageService } from 'src/app/shared/services/token-storage.service';
import { ProgramType } from 'src/app/shared/enums/program-type.enum';
import { PpFormInstanceService } from '@app/api/api-services/pp-form-instance.service';
import * as _ from 'lodash';
import { FormInstanceDependenciesApiModel } from '@app/api/api-models';

@Injectable()
export class RejectSummariesModalProxyService {
  constructor(
    private readonly formInstanceService: FormInstancesService,
    private readonly ppFormInstanceService: PpFormInstanceService,
    private readonly tokenStorage: TokenStorageService
  ) {}

  public displayRejectionModal(
    bsModalService: BsModalService,
    formInstanceId: number | number[],
    successCallback: Function,
    cancelCallback: Function,
    errorCallback: Function,
    customCallback?: Function,
    isDeleteMode?: boolean
  ): void {
    const formInstanceIds = Array.isArray(formInstanceId) ? formInstanceId : [formInstanceId];
    const subscribeParameters = {
      next: this.processSummaries.bind(
        this,
        bsModalService,
        successCallback,
        cancelCallback,
        customCallback,
        isDeleteMode
      ),
      error: () => {
        if (errorCallback) {
          errorCallback();
        }
        if (cancelCallback) {
          cancelCallback();
        }
      }
    };

    this.tokenStorage.userInfo.CurrentProgram.Type === ProgramType.FieldTraining
      ? this.formInstanceService.getSummariesMultipleByIds(formInstanceIds).subscribe(subscribeParameters)
      : this.ppFormInstanceService.getSummariesMultipleByIds(formInstanceIds).subscribe(subscribeParameters);
  }

  private processSummaries(
    bsModalService: BsModalService,
    successCallback: Function,
    cancelCallback: Function,
    customCallback: Function,
    isDeleteMode: boolean,
    summaries: Array<FormInstanceDependenciesApiModel>
  ): void {
    const summariesArrayWrapped = [summaries].flat();
    const bindedForms = summariesArrayWrapped.filter((x) => x.BindedForms.length > 0).map((x) => x.BindedForms);
    const flattenSummaries = _.uniqBy(_.flatten(bindedForms), 'Id');
    if (flattenSummaries.length === 0) {
      customCallback();
      return;
    }

    const mode = isDeleteMode ? 'delete' : 'reject';

    const initialState = {
      confirm: successCallback,
      cancel: cancelCallback,
      mode: mode,
      summaryFormInstances: flattenSummaries
    };

    bsModalService.show(RejectSummariesModalComponent, {
      initialState,
      backdrop: 'static'
    });
  }
}
